export default {
  timeIntervalBetweenDataMinutes: {
    maxLength: 3,
    precision: 0,
    minValue: 1,
    maxValue: 360,
  },
  environmentTemperature: {
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
  },
  loading: {
    maxLength: 7,
    precision: 3,
    minValue: 0,
    maxValue: 200,
  },
  simulationRepetitionsNumber: {
    maxLength: 3,
    precision: 0,
    minValue: 0,
    maxValue: 200,
  },
};
